module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/146-gambia-aef8f241ff49a31197874f5b4edf270d.svg";